import React, { useCallback } from "react";
import AddIcon from "@material-ui/icons/Add";

import { NormalizersTable } from "../../../../../../../../../../components/NormalizersTable/NormalizersTable";
import { ButtonIcon } from "../../../../../../../../../../components/Buttons/ButtonIcon/ButtonIcon";

import styles from "./styles.module.scss";

const Normalizers = ({ initialValues, setInitialValues, onOpenNormalizerDialog }) => {
    const dataNormalizers = initialValues.normalizers;

    const handleDeleteNormalizer = useCallback(
        (index) => {
            const newInitialValues = { ...initialValues };

            newInitialValues.normalizers = initialValues.normalizers.reduce(
                (acc, normalizer, itemIndex) => {
                    if(itemIndex !== index) {
                        acc.push(normalizer);
                    }

                    return acc;
                },
                []
            );

            setInitialValues(newInitialValues);
        },
        [ initialValues, setInitialValues ]
    );

    const handleReorderDataNormalizer = useCallback(
        (normalizers) => {
            const newInitialValues = { ...initialValues };

            newInitialValues.normalizers = normalizers;
            setInitialValues(newInitialValues);
        },
        [ initialValues, setInitialValues ]
    );

    return (
        <>
            <div className={styles.title}>
                <b>Normalizers</b>

                <ButtonIcon
                    warning
                    onClick={() => onOpenNormalizerDialog()}
                    title={"Add Normalizer"}
                >
                    <AddIcon/>
                </ButtonIcon>
            </div>

            <NormalizersTable
                dataNormalizers={dataNormalizers}
                onEdit={onOpenNormalizerDialog}
                onDelete={handleDeleteNormalizer}
                reorderDataNormalizer={handleReorderDataNormalizer}
            />
        </>
    );
};

export default Normalizers;
